import classNames from 'classnames';
import { ButtonAppearance, ButtonSize, TButtonSize, TButtonSpinnerColor, TButtonStyle } from '../types';
import theme from 'src/constants/styles';

export const getButtonStyle = ({ stretched, appearance, size, className, loading, disabled }: TButtonStyle): string => {
  const appearanceClass: string = `button-appearance_${String(appearance)}`;
  const sizeClass: string = `button-size_${String(size)}`;

  return classNames('button', appearanceClass, sizeClass, className, {
    ['button_stretched']: stretched,
    ['disabled']: !loading && disabled,
    [`${appearanceClass}-loading cursor-not-allowed`]: loading,
  });
};

export const getButtonSpinnerSize = (size: TButtonSize): number => {
  switch (size) {
    case ButtonSize.SMALL:
      return 14;
    case ButtonSize.LARGE:
      return 21;
    case ButtonSize.MEDIUM:
    default:
      return 16;
  }
};

export const getButtonSpinnerColor = ({ appearance, spinnerColor }: TButtonSpinnerColor): string => {
  switch (true) {
    case Boolean(spinnerColor):
      return spinnerColor!;
    case appearance === ButtonAppearance.PRIMARY:
    case appearance === ButtonAppearance.DESTRUCTIVE_PRIMARY:
      return theme.colors.white;
    case appearance === ButtonAppearance.SECONDARY:
      return theme.colors.blue2;
    case appearance === ButtonAppearance.TERTIARY:
      return theme.colors.dark;
    case appearance === ButtonAppearance.DESTRUCTIVE_SECONDARY:
    case appearance === ButtonAppearance.DESTRUCTIVE_TERTIARY:
      return theme.colors.redrich;
    default:
      return theme.colors.white;
  }
};
